import { Dispatch, SetStateAction, JSX } from 'react';
import { MdOutlineTableRows, MdShowChart } from 'react-icons/md';
import { DownloadDropdown } from '@Components/DownloadDropdown';
import { Design, Size } from '@Components/designConstants';
import { IconSegmentedControlButton } from '@Components/SegmentedControlButton';

interface PinnedRightActionsProps {
  showPinnedTableView: boolean;
  setShowPinnedTableView: Dispatch<SetStateAction<boolean>>;
}

export const PinnedRightActions = ({
  showPinnedTableView,
  setShowPinnedTableView
}: PinnedRightActionsProps): JSX.Element => (
  <div className='ef-pinned-right-actions'>
    {/* Hidden for Tinuiti Live - restore when feature is ready */}
    {/* <Button
        variant={ButtonFrameworkVariant.TRAILING_ICON}
        design="secondary"
        background="light"
        size="sm"
        icon={<MdAdd />}
        onClick={() => {}}
      >
        Show % Change
      </Button>
      <Button
        variant={ButtonFrameworkVariant.TRAILING_ICON}
        design="secondary"
        background="light"
        size="sm"
        icon={<MdAdd />}
        onClick={() => {}}
      >
        Add Spend Point
      </Button> */}
    <IconSegmentedControlButton
      options={[
        { key: 'showTable', icon: <MdOutlineTableRows />, label: 'table view' },
        { key: 'showGraph', icon: <MdShowChart />, label: 'graph view' }
      ]}
      selectedOption={showPinnedTableView ? 'showTable' : 'showGraph'}
      onChange={value => setShowPinnedTableView(value === 'showTable')}
      size={Size.SM}
      design={Design.NEUTRAL}
    />
    <DownloadDropdown
      size={Size.SM}
      onClickOptions={[() => {}, () => {}]}
      disabledMenuOptions={
        showPinnedTableView ? { XLSX: false, PNG: false } : { XLSX: false, PNG: true }
      }
    />
  </div>
);
